import React, { useContext, useState, useCallback, useMemo, createContext } from 'react';
import styles from 'assets/css/Card.module.css';
//import styles from 'assets/css/StatusMessage.module.css';
import { statusMessageHelpers, STATUS_STATE } from 'utils/statusUtils';

const AttentionContext = createContext(null);

export function AttentionContextProvider(props) {
    //state
    const [attention, setAttention] = useState(null);

    const setAttentionInfo = useCallback(() => { setAttention(statusMessageHelpers.getStatusStateBorderClass(STATUS_STATE.INFO)); }, []);
    const setAttentionWarning = useCallback(() => { setAttention(statusMessageHelpers.getStatusStateBorderClass(STATUS_STATE.WARN)); }, []);
    const setAttentionAlert = useCallback(() => { setAttention(statusMessageHelpers.getStatusStateBorderClass(STATUS_STATE.ALERT)); }, []);
    const clearAttentionState = useCallback(() => { setAttention(null); }, []);

    const attentionContextValue = useMemo(
        () => ({
            attentionState: attention,
            setAttentionInfo,
            setAttentionWarning,
            setAttentionAlert,
            clearAttentionState
        }),
        [attention, setAttentionInfo, setAttentionWarning, setAttentionAlert, clearAttentionState]
    );

    //render
    return useMemo(
        () => (
            <AttentionContext.Provider value={attentionContextValue}> 
                {props.children}
            </AttentionContext.Provider>
        ), [attentionContextValue, props.children]
    );
}

export function useAttentionState() {
    const {
        attentionState
    } = useContext(AttentionContext);

    return useMemo(
        () => ({
            attentionState,
        }), 
        [attentionState]
    );
}

export default function useAttention() {
    const {
        setAttentionInfo,
        setAttentionWarning,
        setAttentionAlert,
        clearAttentionState
    } = useContext(AttentionContext);

    return useMemo(
        () => ({
            setAttentionInfo: () => { setAttentionInfo() },
            setAttentionWarning: () => { setAttentionWarning() },
            setAttentionAlert: () => { setAttentionAlert() },
            clearAttentionState: () => { clearAttentionState() }
        }), [setAttentionInfo, setAttentionWarning, setAttentionAlert, clearAttentionState]
    );
}